import React from "react";

const Section2 = () => {
  return (
    <div className="relative w-full h-full font-montserrat text-white">
    <video
      className="absolute top-0 left-0 w-full h-full object-cover"
      src="/assets/bg/DIV 2.mp4"
      autoPlay
      loop
      muted
    ></video>
      <div className="   relative z-10">
        <div className=" bg-black/30 bg-cover flex flex-col justify-center py-10">
          <div className=" relative ">
            <div className="w-[60%] mx-auto h-14 blur-2xl rounded-full bg-[#f6ffe954] "></div>
            <p className="lg:w-[70%] w-[95%] absolute top-0 left-0 right-0 mx-auto text-center text-xl sm:text-2xl lg:text-4xl font-bold ">
            Decentralized Stablecoin Platform on Avalanche Subnet

            </p>
            <p className=" text-center text-sm  mt-7 font-medium">
            Efficient, Secure, and Scalable Stablecoin Transactions
            </p>
          </div>
          <div className="w-[85%] mx-auto gap-20 flex lg:flex-row flex-col justify-center items-center mt-10">
            <div className="lg:w-1/2">
              <img src="../assets/other/section2.svg" className=" mx-auto" />
            </div>
            <div className="lg:w-1/2 flex flex-col gap-10">
              <div className=" bg-gradient-to-l from-[#FFFAD1A3] to-[#C4C4C400] rounded-lg py-4 px-5 ">
                <div className=" flex flex-col justify-end items-end ">
                  <p className="text-lg font-bold">Seamless Stablecoin Transfers</p>
                  <p className=" text-center text-sm">
                  Easily transfer stablecoins with cross-chain compatibility for seamless interoperability.

                  </p>
                </div>
              </div>
              <div className=" bg-gradient-to-l from-[#FFFAD1A3] to-[#C4C4C400] rounded-lg py-4 px-5 ">
                <div className=" flex flex-col justify-end items-end ">
                  <p className="text-lg font-bold">Revolutionary Gas Fee Mechanism
</p>
                  <p className=" text-center text-sm">Gas fees are paid directly in USDT, simplifying the transaction process.</p>
                </div>
              </div>
              <div className=" bg-gradient-to-l from-[#FFFAD1A3] to-[#C4C4C400] rounded-lg py-4 px-5 ">
                <div className=" flex flex-col justify-end items-end ">
                  <p className="text-lg font-bold">Built for Speed and Scalability</p>
                  <p className=" text-center text-sm">
                  Experience lightning-fast transactions powered by Avalanche Subnet, with near-instant finality ideal for high-frequency transfers.

                  </p>
                </div>
              </div>
              <div className=" bg-gradient-to-l from-[#FFFAD1A3] to-[#C4C4C400] rounded-lg py-4 px-5 ">
                <div className=" flex flex-col justify-end items-end ">
                  <p className="text-lg font-bold">Robust Security and Compliance
                  </p>
                  <p className=" text-center text-sm">
                  Implemented with smart contract architecture and rigorous security audits.

                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;